<ng-container *transloco="let t;">
<div class="table-listing">
    <!-- @Todo Once the data table feature will approved then i will remove it (Fahad11-dev) -->
    <!-- <div class="col-12 full-height p-0">
        <div class="card full-height mb-0">
            <div class="table-responsive">
                @if (isLoading$ | async) {
                    <app-skeleton [loop]="8" [section]="'documentslisting-Loader'"></app-skeleton>
                } @else {
                    <ng-template #noDocuments>{{ t('No document table notification (document listing) - No documents found') }}</ng-template>
                    <app-table [columns]="mappedColumns$ | async"
                               [data]="documentsList$ | async"
                               [emptyDataTemplate]="noDocuments"
                               [selectable]="selectable"
                               (rowClicked)="onRowClicked($event)"
                               (selectionChanged)="onSelectionChange($event)"
                               [selection]="selection$ | async"
                    ></app-table>
                
                        <div class="d-flex justify-content-between align-content-center mt-1 w-100">
                            <div class="mt-2 ms-1">
                                <p class="mb-0 font-small-3">{{t('Total Documents text - (Documents Section) - Total Documents')}}: {{(paging$ | async)?.total}}</p>
                            </div>
                          @if (paging$ | async; as paging) {
                                <app-table-pager [pagerOptions]="paging"
                                                 (pageChange)="onPageChange($event)"></app-table-pager>
                            }
                        </div>
                }
            </div>
                <div class="d-flex justify-content-end align-content-center mt-1  pull-right">
                    @if (selectable && (selection$ | async)?.length > 0) {
                        <button type="button" class="btn btn-outline-secondary"
                                rippleEffect (click)="onDeleteSelectedDocumentsClick()">
                            <span *ngIf="isDeletingDocumentsInProgress$ | async" class="spinner-border spinner-border-sm me-1"></span>
                            {{ t('Delete button text (delete button) - delete') }}
                        </button>
                        <button type="button" class="btn btn-success ms-1" rippleEffect (click)="onRestoreSelectedDocumentsClick()">
                            <span *ngIf="isRestoringDocumentsInProgress$ | async" class="spinner-border spinner-border-sm me-1"></span>
                            {{ t('Restore document button (document trash) - Restore') }}
                        </button>
                    }
                </div>
        </div>
    </div> -->
    
    <div class="col-12 p-0">
        <div class="card mb-0">
            <div class="table-responsive">
                @if (isLoading$ | async) {
                    <app-skeleton [loop]="8" section="documentslisting-Loader"></app-skeleton>
                } @else {
                    <div>
                        <ngx-datatable
                            class="bootstrap core-bootstrap datatable-bordered virtualized material datatable-striped expandable"
                            [headerHeight]="40"
                            [rowHeight]="58"
                            [rowWidth]="auto"
                            [selected]="selection$ | async"
                            [rows]="documentsList$ | async"
                            [columnMode]="ColumnMode.force"
                            [selectAllRowsOnPage]="false"
                            [scrollbarV]="true"
                            [scrollbarH]="true"
                            [enableClearingSortState]="true"
                            [selectionType]="SelectionType.checkbox"
                            (select)="onSelectionChange($event?.selected ?? [])"
                            (activate)="onActivate($event)"
                            [sorts]="[{ prop: 'created_at', dir: 'desc' }]"
                            (reorder)="onColumnReorder($event)"
                            (resize)="onColumnResize($event)"
                        >

                         @if (selectable){
                             <ngx-datatable-column
                                     [cellClass]="'selection-column'"
                                     [width]="43"
                                     [sortable]="false"
                                     [canAutoResize]="false"
                                     [draggable]="false"
                                     [resizeable]="false"
                                     [headerCheckboxable]="true"
                                     [checkboxable]="true"
                             >
                             </ngx-datatable-column>
                         }
  
                        @for(column of mappedColumns$ | async; track column) {
                            <ngx-datatable-column [name]="column.title" [prop]="column.field === 'document_type' ? (row?.visible_name ? 'visible_name' : 'name') : column.field" [sortable]="true" [reorderable]="true" [resizable]="true" [width]="column?.details?.width">
                                <ng-template #cellRef let-row="row" ngx-datatable-cell-template>
                                    <datatable-row-def [appTableCellContent]="[row, column, cellRef]" />
                                </ng-template>
                            </ngx-datatable-column>
                        }
                        </ngx-datatable>
                    </div>
                }
                <div class="d-flex justify-content-between align-content-center mt-1 w-100">
                    <div class="mt-2 ms-1">
                        <p class="mb-0 font-small-3">{{t('Total Documents text - (Documents Section) - Total Documents')}}: {{(paging$ | async)?.total}}</p>
                    </div>
                    @if (paging$ | async; as paging) {
                        <app-table-pager [pagerOptions]="paging"
                                            (pageChange)="onPageChange($event)"></app-table-pager>
                    }
                </div>
                <div class="d-flex justify-content-end align-content-center mt-1  pull-right">
                    @if (selectable && (selection$ | async)?.length > 0) {
                        <button type="button" class="btn btn-outline-secondary"
                                rippleEffect (click)="onDeleteSelectedDocumentsClick()">
                            <span *ngIf="isDeletingDocumentsInProgress$ | async" class="spinner-border spinner-border-sm me-1"></span>
                            {{ t('Delete button text (delete button) - delete') }}
                        </button>
                        <button type="button" class="btn btn-success ms-1" rippleEffect (click)="onRestoreSelectedDocumentsClick()">
                            <span *ngIf="isRestoringDocumentsInProgress$ | async" class="spinner-border spinner-border-sm me-1"></span>
                            {{ t('Restore document button (document trash) - Restore') }}
                        </button>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>